export { default } from '~/screens/404';
